import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { querySiteList } from '@/api/api';
import { getAction } from '@api/manage';
import moment from 'moment';
export default {
  data: function data() {
    return {
      companyDetail: {},
      companyId: '',
      siteList: []
    };
  },
  watch: {
    companyId: function companyId() {
      // 获取企业下的站点列表
      if (this.companyId) {
        this.getSiteList(this.companyId);
      }
    }
  },
  methods: {
    getRealTime: function getRealTime(scopeId, st) {
      var _this = this;

      getAction('/online/cn2011', {
        column: 'data_time',
        order: 'desc',
        stime: moment().subtract(1, 'hour').format('YYYY-MM-DD HH:mm:ss'),
        etime: moment().format('YYYY-MM-DD') + ' 23:59:59',
        scopeId: scopeId,
        scope: 1,
        st: st,
        current: 1,
        size: 1
      }).then(function (res) {
        if (res.success) {
          _this.siteList.some(function (item) {
            if (item.id == scopeId) {
              item.dataList = res.result;
            }

            _this.$forceUpdate();

            return item.id == scopeId;
          });
        }
      });
    },
    getSiteList: function getSiteList(companyId) {
      var _this2 = this;

      querySiteList({
        companyId: companyId,
        size: -1
      }).then(function (res) {
        if (res.success) {
          _this2.siteList = res.result.records || [];

          _this2.siteList.forEach(function (item) {
            item.dataList = {};

            _this2.getRealTime(item.id, item.st);
          });
        }
      });
    },
    close: function close() {
      this.$emit('close', false);
    },
    ontoSite: function ontoSite(item) {
      var _this3 = this;

      sessionStorage.setItem('selectId', JSON.stringify(item));
      setTimeout(function () {
        _this3.$router.push({
          path: '/online/site',
          query: {
            siteId: item.id,
            siteName: item.name,
            st: item.st
          }
        });
      }, 1000);
    }
  }
};